<template>
  <div class="container">
    <b-form-file
      ref="chooseFile"
      v-if="!uploading"
      v-show="!isNativePlatform"
      v-model="file"
      :disabled="disabled"
      :placeholder="$t('chooseFile')"
      :drop-placeholder="$t('chooseFile')"
      :browse-text="$t('choose')"
      accept="image/png,image/jpeg,application/pdf,.doc,.docx,.dotx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.xlsx,.xls,.xlsm,.xlsb,.xltx,.xltm,.ppt,.pptx"
      @change="handleFiles"
    ></b-form-file>
    <b-form-file
      ref="takePicture"
      v-if="!uploading"
      v-show="false"
      v-model="file"
      :disabled="disabled"
      :placeholder="$t('chooseFile')"
      :drop-placeholder="$t('chooseFile')"
      :browse-text="$t('choose')"
      accept="image/*"
      capture="environment"
      @change="handleFiles"
    ></b-form-file>
    <b-button
      v-if="!uploading && isNativePlatform"
      :disabled="disabled"
      variant="outline-dark"
      @click="chooseFile()"
      class="mr-2"
    >
      <span class="icon"><i class="fas fa-file mr-2"></i></span>
      {{ $t("chooseFile") }}
    </b-button>
    <b-button v-if="!uploading && isNativePlatform" :disabled="disabled" variant="outline-dark" @click="takePicture()">
      <span class="icon"><i class="fas fa-camera mr-2"></i></span>
      {{ $t("takePicture") }}
    </b-button>
    <b-spinner v-if="uploading" label="Spinning" class="mt-2"></b-spinner>
  </div>
</template>

<script>
import { Document } from "@/models/Document";
import DocumentService from "@/services/DocumentService";
import { Capacitor } from "@capacitor/core";

export default {
  name: "pwFileUpload",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    anonymousUpload: {
      type: Boolean,
      default: false
    },
    isPublic: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      file: null,
      uploading: false,
      api_v: this.$route.params.v,
      attached_id: this.$route.params.id,
      attached_token: this.$route.params.token
    };
  },
  mounted() {},
  methods: {
    chooseFile() {
      const inputElement = this.$refs.chooseFile.$el.querySelector('input[type="file"]');
      if (inputElement) {
        inputElement.click();
      }
    },
    takePicture() {
      const inputElement = this.$refs.takePicture.$el.querySelector('input[type="file"]');
      if (inputElement) {
        inputElement.click();
      }
    },
    handleFiles(event) {
      this.uploading = true;

      let file = event.target.files[0];
      let filename = event.target.files[0].name;

      let document = null;
      let document2 = null;

      if (file.type === "" && file.name.endsWith(".msg")) {
        let mailFile = new File([file], file.name, { type: "application/vnd.ms-outlook" });
      }

      if (document2 == null) {
        document = new Document({ name: filename, filepath: file });
      } else {
        document = new Document({ name: filename, filepath: mailFile });
      }

      if (this.anonymousUpload) {
        DocumentService.createWhistleblowerDocument(document, this.$route.params.id)
          .then((document) => {
            this.$emit("upload", document);
          })
          .finally(() => (this.uploading = false));
        return;
      } else if (this.isPublic) {
        DocumentService.createExternalDocument(this.api_v, this.attached_token, this.attached_id, document)
          .then((document) => {
            this.$emit("upload", document);
          })
          .finally(() => (this.uploading = false));
        return;
      } else {
        DocumentService.createDocument(document)
          .then((document) => {
            this.$emit("upload", document);
          })
          .finally(() => (this.uploading = false));
      }
    }
  },
  computed: {
    isNativePlatform() {
      return Capacitor.isNativePlatform();
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  display: inline;
  margin: 0;
  padding: 0;
}
</style>
